export default {
    quickActionsMap: [
        {
            key: "blocco-vas",
            message: "Verifica/gestione servizi a sovrapprezzo",
            conversation: "wfp"
        },
        {
            key: "legge-bilancio",
            message: "legge di bilancio",
            conversation: "wfp"
        }
    ],
    xmppCreds: {
        user: "",
        token: "",
        thread: "",
    },
};
